/* eslint-disable no-param-reassign */
/**
 * Creates boilerplate mutations based on the state object provided.
 * Mutation names are in uppercase snake case.
 *
 * @param {Object} stateObj - The state object containing properties.
 * @param {string} [prefix=''] - Optional prefix for mutation names.
 * @returns {Object} - The object storing mutation functions.
 */
const createMutationsFactory = (stateObj, prefix = '') => {
  const mutations = {};

  const toUpperCaseSnakeCase = (str) => str.replace(/([A-Z])/g, '_$1').toUpperCase();

  Object.keys(stateObj).forEach((prop) => {
    let baseName;
    if (prop.charAt(0) === '_') {
      baseName = `${prop.charAt(1).toUpperCase()}${prop.slice(2)}`;
    } else {
      baseName = `${prop.charAt(0).toUpperCase()}${prop.slice(1)}`;
    }
    const mutationName = toUpperCaseSnakeCase(`set${prefix}${baseName}`);

    mutations[mutationName] = (state, payload) => {
      state[prop] = payload;
    };
  });
  return mutations;
};

export default createMutationsFactory;
